<template>
  <div
      :class="content.type">

    <v-icon @click="set_icon(content)"
            :class="content.classes + ' content'"
            :style="'color:'+content.text_color">
      {{ content.icon }}
    </v-icon>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import store from '@/store/';

export default {
  props: {
    content: Object
  },
  components: {},
  data() {
    return {
      icon_dialog: false,
    }
  },
  computed: {
    ...mapActions([
        'setIconBlock'
    ])
  },
  methods: {
    set_icon: (content) => {
      console.log(store);
      let payload = {
        item: content,
        active: true
      }
      store.dispatch('setIconBlock', payload).then(() => {
        console.log('opened ? ');
      })
    },
    close_icon_dialog() {
      this.icon_dialog = false;
    }
  }
}
</script>
